const DEFAULT_CLASS_NAME_FADE_IN = 'fadeIn';
const DEFAULT_TRANSITION = '0.5s';
const DEFAULT_BEFORE_OPACITY = '0';
const DEFAULT_BEFORE_TRANSFORM = 'translateY(50%)';
const DEFAULT_AFTER_OPACITY = '1';
const DEFAULT_AFTER_TRANSFORM = 'translateY(0)';

export {
  DEFAULT_CLASS_NAME_FADE_IN,
  DEFAULT_TRANSITION,
  DEFAULT_BEFORE_OPACITY,
  DEFAULT_BEFORE_TRANSFORM,
  DEFAULT_AFTER_OPACITY,
  DEFAULT_AFTER_TRANSFORM,
};
